"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementDataFromJSON = MeasurementDataFromJSON;
exports.MeasurementDataFromJSONTyped = MeasurementDataFromJSONTyped;
exports.MeasurementDataToJSON = MeasurementDataToJSON;
exports.MeasurementDataToJSONTyped = MeasurementDataToJSONTyped;
const runtime_1 = require("../runtime");
function MeasurementDataFromJSON(json) {
    return MeasurementDataFromJSONTyped(json, false);
}
function MeasurementDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contentId': !(0, runtime_1.exists)(json, 'contentId') ? undefined : json['contentId'],
        'eventName': json['eventName'],
        'value': json['value'],
    };
}
function MeasurementDataToJSON(value) {
    return MeasurementDataToJSONTyped(value, false);
}
function MeasurementDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contentId': value.contentId,
        'eventName': value.eventName,
        'value': value.value,
    };
}
